import { ApiEndpoints } from '../../core/constants'
import { AccountNotificationTypes, BudgetNotificationTypes } from '../../core'

export const getNotificationDetailRoute = (notificationType: number) => {
  switch (notificationType) {
    case BudgetNotificationTypes.BudgetExceeded:
    case BudgetNotificationTypes.BudgetOffTarget:
      return ApiEndpoints.BUDGETS
    case AccountNotificationTypes.DebtPaymentReminder:
    case AccountNotificationTypes.AccountBalanceLow:
    case AccountNotificationTypes.AccountDepositLarge:
      return ApiEndpoints.ACCOUNTS
    case AccountNotificationTypes.TransactionExpenseLarge:
    case AccountNotificationTypes.TransactionFeeCharge:
    case AccountNotificationTypes.InternationalTransaction:
      return ApiEndpoints.TRANSACTIONS
    default:
      return null
  }
}
